var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.37225,1.875C6.923500000000001,1.875,12.5,1.875,12.5,1.875C12.5,1.875,16.875,6.875,16.875,6.875C16.875,6.875,16.875,13.9629,16.875,16.886699999999998C16.875,17.5771,16.2964,18.125,15.6061,18.125C12.98767,18.125,7.01233,18.125,4.39392,18.125C3.703565,18.125,3.125,17.5833,3.125,16.892899999999997C3.125,13.8727,3.125,6.12732,3.125,3.1070599999999997C3.125,2.4167,3.681896,1.875,4.37225,1.875",
    fillRule: "evenodd",
    fill: "#FF9000",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.75,6.25C8.75,6.25,10,6.25,10,6.25C10,6.25,10,7.5,10,7.5C10,7.5,8.75,7.5,8.75,7.5C8.75,7.5,8.75,6.25,8.75,6.25Z",
    fill: "#FFFFFF",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 7.5,
    width: 1.25,
    height: 1.25,
    rx: 0,
    fill: "#FFFFFF",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 8.75,
    width: 1.25,
    height: 1.25,
    rx: 0,
    fill: "#FFFFFF",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 1.25,
    height: 1.25,
    rx: 0,
    fill: "#FFFFFF",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.53125,
    y: 12.65625,
    width: 0.9375,
    height: 0.9375,
    rx: 0,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#FFFFFF",
    fill: "none",
    strokeWidth: 1.5625
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,1.875C12.5,1.875,12.5,4.1195,12.5,5.6008700000000005C12.5,6.29123,13.057254,6.875,13.74761,6.875C15.04075,6.875,16.875,6.875,16.875,6.875C16.875,6.875,12.5,1.875,12.5,1.875Z",
    fillRule: "evenodd",
    fill: "#EB8D00",
    fillOpacity: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.f936f06071f56fdf4b9d8cbfb3ba482b.svg";
export { ForwardRef as ReactComponent };